// MODÜL 13: UÇAK TİPLERİ & KABİN

const cabinCrewContentsM13 = {
  // ==================== AIRBUS AİLESİ ====================
  'CM-M13-U1-L1': {
    lesson_id: 'CM-M13-U1-L1',
    title: 'Airbus A320 Ailesi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Airbus A320 Ailesi',
      paragraphs: [
        'A320 ailesi, dünyanın en popüler dar gövde uçak ailesidir. 1988\'den beri üretiliyor.',
        'A318: En küçük üye. 107-132 yolcu. Kısa hatlar için.',
        'A319: 124-156 yolcu. Orta mesafe için ideal.',
        'A320: Ana model. 150-186 yolcu. En çok satan versiyon.',
        'A321: En büyük. 185-236 yolcu. A321neo ile uzun menzil.',
        'NEO (New Engine Option): Yeni nesil motor. Daha az yakıt, daha sessiz.'
      ],
      keyPoints: [
        'A318/A319/A320/A321',
        'Dar gövde (Single-aisle)',
        'NEO = Yeni nesil',
        '150-236 yolcu aralığı'
      ]
    }
  },
  'CM-M13-U1-L2': {
    lesson_id: 'CM-M13-U1-L2',
    title: 'Airbus Geniş Gövde',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Airbus Geniş Gövde Uçaklar',
      paragraphs: [
        'Geniş gövde (Wide-body): İki koridor, uzun mesafe uçuşlar için.',
        'A330: 250-440 yolcu. Orta-uzun menzil. -200 ve -300 versiyonları.',
        'A350 XWB: Yeni nesil. Karbon kompozit gövde. -900 ve -1000. Çok verimli.',
        'A380: Dünyanın en büyük yolcu uçağı! Çift katlı. 500-850 yolcu. Üretimi durdu.',
        'THY Filosu: A330, A350 uzun mesafe uçuşlarında kullanılıyor.'
      ],
      keyPoints: [
        'A330: Orta-uzun menzil',
        'A350 XWB: Karbon, verimli',
        'A380: En büyük, çift katlı',
        'Wide-body = 2 koridor'
      ]
    }
  },
  'CM-M13-U1-L3': {
    lesson_id: 'CM-M13-U1-L3',
    title: 'Airbus Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'A320 ailesinin en büyük üyesi?', options: ['A318', 'A319', 'A320', 'A321'], correct: 3 },
        { q: 'NEO ne anlama gelir?', options: ['New Engine Option', 'Next Evolution', 'Nano Engine', 'New Era'], correct: 0 },
        { q: 'Dünyanın en büyük yolcu uçağı?', options: ['A350', 'A330', 'A380', '787'], correct: 2 },
        { q: 'Karbon kompozit gövdeli Airbus?', options: ['A330', 'A350', 'A380', 'A320'], correct: 1 },
        { q: 'Wide-body ne demek?', options: ['Tek koridor', 'İki koridor', 'Kısa mesafe', 'Küçük uçak'], correct: 1 }
      ]
    }
  },

  // ==================== BOEING AİLESİ ====================
  'CM-M13-U2-L1': {
    lesson_id: 'CM-M13-U2-L1',
    title: 'Boeing 737 Ailesi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Boeing 737 Ailesi',
      paragraphs: [
        '737, tarihin en çok üretilen jet uçağıdır. 1967\'den beri üretiliyor.',
        '737-800: En popüler versiyon. 162-189 yolcu. SunExpress filosunun temeli.',
        '737 MAX: Yeni nesil. MAX 8, MAX 9, MAX 10. 2019 krizinden sonra geri döndü.',
        'Winglet: Kanat uçlarındaki dikey parçalar. Yakıt tasarrufu sağlar.',
        'Pegasus ve SunExpress 737 operatörü.'
      ],
      keyPoints: [
        'En çok üretilen jet',
        '737-800 en popüler',
        '737 MAX yeni nesil',
        'Dar gövde, tek koridor'
      ]
    }
  },
  'CM-M13-U2-L2': {
    lesson_id: 'CM-M13-U2-L2',
    title: 'Boeing Geniş Gövde',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Boeing Geniş Gövde Uçaklar',
      paragraphs: [
        '777: "Triple Seven". Uzun mesafe kralı. 300-550 yolcu. THY\'nin amiral gemisi.',
        '777-300ER: Extended Range. THY\'nin uzun mesafe işçisi.',
        '787 Dreamliner: Karbon kompozit. Çok verimli. -8, -9, -10 versiyonları.',
        '747: "Jumbo Jet". 1970\'lerden beri. Çift katlı burun. Yolcu versiyonu azalıyor.',
        '747-8: En yeni 747. Kargo ve VIP kullanımı ağırlıklı.'
      ],
      keyPoints: [
        '777-300ER: Uzun mesafe',
        '787: Dreamliner, karbon',
        '747: Jumbo, çift kat burun',
        'THY: 777 ve 787 kullanır'
      ]
    }
  },
  'CM-M13-U2-L3': {
    lesson_id: 'CM-M13-U2-L3',
    title: 'Boeing Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'En çok üretilen jet uçak?', options: ['A320', '737', '777', '787'], correct: 1 },
        { q: 'Triple Seven hangi uçak?', options: ['747', '757', '767', '777'], correct: 3 },
        { q: 'Dreamliner hangi uçak?', options: ['737', '747', '777', '787'], correct: 3 },
        { q: 'Jumbo Jet hangi uçak?', options: ['737', '747', '777', '787'], correct: 1 },
        { q: '737 MAX ne zaman krize girdi?', options: ['2017', '2018', '2019', '2020'], correct: 2 }
      ]
    }
  },

  // ==================== KABİN DÜZENİ ====================
  'CM-M13-U3-L1': {
    lesson_id: 'CM-M13-U3-L1',
    title: 'Kabin Bölümleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Bölümleri',
      paragraphs: [
        'Galley: Mutfak alanı. Yemek ve içecek hazırlığı. Ön ve arka galley olabilir.',
        'Lavatory: Tuvalet. LAV kodları ile belirtilir. Duman dedektörü zorunlu.',
        'Jumpseat: Kabin ekibi koltukları. Kalkış/iniş için. Çoğu kapı yanında.',
        'Overhead Bin: Üst bagaj bölmesi. Kabin ekibi kapatmaktan sorumlu.',
        'PSU (Passenger Service Unit): Yolcu üstü panel. Işık, havalandırma, oksijen maskesi.'
      ],
      keyPoints: [
        'Galley = Mutfak',
        'Lavatory = Tuvalet',
        'Jumpseat = Ekip koltuğu',
        'PSU = Yolcu servis paneli'
      ]
    }
  },
  'CM-M13-U3-L2': {
    lesson_id: 'CM-M13-U3-L2',
    title: 'Acil Çıkışlar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Acil Çıkış Kapıları',
      paragraphs: [
        'Type A Door: En büyük. 110 yolcu/dakika tahliye kapasitesi.',
        'Type B/C Door: Orta boy kapılar.',
        'Overwing Exit: Kanat üstü çıkış. Yolcu tarafından açılabilir.',
        'Slide/Raft: Kapı açılınca otomatik şişen kaydırak. Su üzerinde sal olur.',
        'Arming: Kapıyı "armed" konuma almak. Slide otomatik açılır. "Disarmed" = pasif.'
      ],
      keyPoints: [
        'Type A = En büyük kapı',
        'Overwing = Kanat üstü',
        'Slide/Raft = Kaydırak/Sal',
        'Armed vs Disarmed'
      ]
    }
  },
  'CM-M13-U3-L3': {
    lesson_id: 'CM-M13-U3-L3',
    title: 'Koltuk Düzenleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Koltuk Düzenleri',
      paragraphs: [
        'Dar gövde: 3-3 (A320, 737). Koridor tek.',
        'Geniş gövde: 2-4-2 (A330), 3-3-3 (777 ekonomi), 1-2-1 (business).',
        'Economy: En sıkı düzenleme. 29-32 inch seat pitch.',
        'Business: 38-42 inch pitch veya full-flat yatak.',
        'First Class: Suite, kapılı kabinler. Sadece bazı uçaklarda.'
      ],
      keyPoints: [
        'Dar gövde: 3-3',
        'Geniş gövde: 2-4-2, 3-3-3',
        'Seat pitch = Koltuk aralığı',
        'Full-flat = Yatay yatak'
      ]
    }
  },
  'CM-M13-U3-L4': {
    lesson_id: 'CM-M13-U3-L4',
    title: 'Kabin Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { id: 1, left: 'Galley', right: 'Mutfak alanı' },
        { id: 2, left: 'Lavatory', right: 'Tuvalet' },
        { id: 3, left: 'Jumpseat', right: 'Ekip koltuğu' },
        { id: 4, left: 'Slide/Raft', right: 'Acil kaydırak' },
        { id: 5, left: 'PSU', right: 'Yolcu servis paneli' }
      ]
    }
  },

  // ==================== UÇAK TANIMA ====================
  'CM-M13-U4-L1': {
    lesson_id: 'CM-M13-U4-L1',
    title: 'Boeing vs Airbus Farkları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Boeing ve Airbus Nasıl Ayırt Edilir?',
      paragraphs: [
        'Burun Şekli: Boeing daha sivri, Airbus daha yuvarlak.',
        'Kokpit Camları: Boeing köşeli (V şekli), Airbus daha düz.',
        '737 vs A320: 737 motorları daha yassı, A320 daha yuvarlak.',
        '777 vs A350: 777 motorları devasa, A350 daha ince ve uzun.',
        'Winglet: Boeing blended winglet, Airbus sharklet (köpekbalığı yüzgeci).'
      ],
      keyPoints: [
        'Burun: Boeing sivri, Airbus yuvarlak',
        'Kokpit: Boeing köşeli cam',
        'Winglet vs Sharklet',
        'Motor boyutları farklı'
      ]
    }
  },
  'CM-M13-U4-L2': {
    lesson_id: 'CM-M13-U4-L2',
    title: 'Uçak Tanıma Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Çift katlı yolcu uçağı, 4 motor?', options: ['777', '787', 'A350', 'A380'], correct: 3 },
        { q: 'Dreamliner olarak bilinen?', options: ['747', '777', '787', 'A350'], correct: 2 },
        { q: 'Triple Seven?', options: ['767', '777', '787', '747'], correct: 1 },
        { q: 'En çok üretilen dar gövde Boeing?', options: ['717', '727', '737', '757'], correct: 2 },
        { q: 'Jumbo Jet lakabı olan?', options: ['A380', '747', '777', 'A350'], correct: 1 }
      ]
    }
  },
  'CM-M13-U4-L3': {
    lesson_id: 'CM-M13-U4-L3',
    title: 'Doğru/Yanlış: Uçaklar',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'A380 dünyanın en büyük yolcu uçağıdır.', isTrue: true, explanation: 'Doğru! A380 en büyük yolcu uçağı.' },
        { statement: '737 Airbus ürünüdür.', isTrue: false, explanation: 'Yanlış! 737 Boeing ürünüdür.' },
        { statement: '787\'nin lakabı Dreamliner\'dır.', isTrue: true, explanation: 'Doğru!' },
        { statement: 'Wide-body uçaklarda tek koridor vardır.', isTrue: false, explanation: 'Yanlış! Wide-body = İki koridor.' },
        { statement: 'NEO yeni motor teknolojisi demektir.', isTrue: true, explanation: 'Doğru! New Engine Option.' }
      ]
    }
  },

  // ==================== FİNAL SINAVI ====================
  'CM-M13-U5-L1': {
    lesson_id: 'CM-M13-U5-L1',
    title: 'Uçak & Kabin Final',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'A320 ailesinin en büyük versiyonu?', options: ['A318', 'A319', 'A320', 'A321'], correct: 3 },
        { q: 'Boeing 777\'nin lakabı?', options: ['Dreamliner', 'Jumbo', 'Triple Seven', 'Max'], correct: 2 },
        { q: 'Galley ne demek?', options: ['Tuvalet', 'Mutfak', 'Kaptan kabini', 'Kargo'], correct: 1 },
        { q: 'Armed/Disarmed ne ile ilgili?', options: ['Motor', 'Kapı slide', 'Koltuk', 'Işık'], correct: 1 },
        { q: 'Seat pitch ne demek?', options: ['Koltuk genişliği', 'Koltuk aralığı', 'Yaşlanma', 'Yükseklik'], correct: 1 },
        { q: 'Overwing exit nerede?', options: ['Burun', 'Kuyruk', 'Kanat üstü', 'Kargo'], correct: 2 },
        { q: 'Sharklet hangi markanın?', options: ['Boeing', 'Airbus', 'Embraer', 'Bombardier'], correct: 1 },
        { q: 'Wide-body kaç koridorlu?', options: ['0', '1', '2', '3'], correct: 2 }
      ]
    }
  }
};

export default cabinCrewContentsM13;
